import React from "react";
import Header from "./Header"; // adjust path if needed
import "../assets/styles/NotFound.scss";

const stamps = Array.from({ length: 20 }, (_, i) => ({
    value: i % 2 === 0 ? "4" : "0",
    index: i + 1,
}));

const NotFound: React.FC = () => {
    return (
        <>
            <Header />

            <main className="not-found-page">
                <div className="not-found-rail">
                    {stamps.map((stamp) => (
                        <div
                            key={stamp.index}
                            className="not-found-stamp"
                            style={
                                {
                                    "--i": stamp.index,
                                } as React.CSSProperties
                            }
                        >
                            {stamp.value}
                        </div>
                    ))}
                </div>

                <div className="not-found-world">
                    <div className="not-found-forward">
                        <div className="not-found-box">
                            <div className="not-found-wall" />
                            <div className="not-found-wall" />
                            <div className="not-found-wall" />
                            <div className="not-found-wall" />
                            <div className="not-found-wall" />
                            <div className="not-found-wall" />
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
};

export default NotFound;